// Sorozat-alkalom szerkesztésének / törlésének HATÓKÖRE: csak ez · ez és a következők · a sorozat összes (jövőbeli)
// alkalma. Két helyen kell (a szerkesztő mentése és a törlés megerősítése), ezért egy komponens. A választás a
// BFF `scope` paramétere; a múltbeli alkalom egyik esetben sem változik.
import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

export type MeetingSeriesScope = 'this' | 'following' | 'all';

const SCOPES: readonly MeetingSeriesScope[] = ['this', 'following', 'all'];

export interface MeetingSeriesScopeOptionsProps {
  value: MeetingSeriesScope;
  onChange: (scope: MeetingSeriesScope) => void;
  /** A művelet (a feliratok igéje: „módosítás" / „törlés"). */
  action: 'edit' | 'delete';
  disabled?: boolean;
}

export function MeetingSeriesScopeOptions({
  value,
  onChange,
  action,
  disabled = false,
}: MeetingSeriesScopeOptionsProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <div
      className="mt-3 space-y-1.5"
      role="radiogroup"
      aria-label={t(`meetings.seriesScope.${action}.label`)}
    >
      {SCOPES.map((scope) => {
        const active = value === scope;
        return (
          <button
            key={scope}
            type="button"
            role="radio"
            aria-checked={active}
            disabled={disabled}
            onClick={() => onChange(scope)}
            className={cn(
              'ease-atlas focus-visible:ring-accent-600 flex w-full flex-col items-start rounded-md border px-3 py-2 text-left text-sm transition-colors duration-150',
              'focus-visible:outline-none focus-visible:ring-2 disabled:pointer-events-none disabled:opacity-50',
              active
                ? 'border-border bg-background text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground border-transparent',
            )}
          >
            <span className="font-medium">{t(`meetings.seriesScope.${action}.${scope}`)}</span>
            <span className="text-subtle text-xs">{t(`meetings.seriesScope.hint.${scope}`)}</span>
          </button>
        );
      })}
    </div>
  );
}
